import { Component, Mixins } from 'vue-property-decorator';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import applicationStore from '@/store/modules/applications/applicationStore';
import APP_UTILITIES from '@/utilities/commonFunctions';
import APP_CONST from '@/constants/AppConst';

@Component
export default class WaitlistDeniedApplications extends Mixins(DeviceWidthCheckerMixin) {
  tooltipIndex = -1;
  styleObj = {};
  tooltipText: string = '';
  LOCAL_CONSTANT = APP_CONST;

  /* istanbul ignore next */
  get siteList(){
    return applicationStore.waitListDeniedApplications;
  }

  formatDate(date: string) {
    return date && APP_UTILITIES.formatDate(date);
  }

  getEnrollStatus(status: number) {
    return status == APP_CONST.SCHOLAR_ENROLL_STATUS_WAITLIST
      ? 'Waitlisted'
      : status == APP_CONST.SCHOLAR_ENROLL_STATUS_PENDING
        ? 'Pending'
        : 'Declined';
  }

  formatTime(date: string): string {
    return APP_UTILITIES.convert12hrFormateTimeFromDate(date);
  }

  showTooltip(val: string, event: any, index: number) {
    this.tooltipIndex = index;
    this.tooltipText = val;
    const boundBox = event && event.target && event.target.getBoundingClientRect();
    const coordX = boundBox.left;
    const coordY = boundBox.top;
    this.styleObj = {
      top: (coordY + 30).toString() + 'px',
      left: (coordX + 30).toString() + 'px'
    };
  }

  hideTooltip() {
    this.tooltipIndex = -1;
    this.tooltipText = '';
  }
}